
import { Component, Vue } from 'vue-property-decorator'
import DatePicker from '@/components/date-picker.vue'
import { apidepositRecordLists } from '@/api/earnest'
import { RequestPaging } from '@/utils/util'
import LsPagination from '@/components/ls-pagination.vue'
import LsDialog from '@/components/ls-dialog.vue'
@Component({
    components: {
        DatePicker,
        LsPagination,
        LsDialog
    }
})
export default class Earnest extends Vue {
    $refs!: { dialog: any }
    // S Data
    activeName: any = 'all' //全部;
    value: any = [1]
    pager = new RequestPaging()
    apidepositRecordLists = apidepositRecordLists
    tabCount = {
        all: 0, //全部
        wait: 0, //待支付
        finish: 0 //已关闭
    }
    form: any = {
        name: '',
        contact: '',
        contact_mobile: ''
    }
    data: any = []
    depositData: any = {
        sid: '',
        type: 1,
        deposit: ''
    }
    sendDeposit: any = ''
    recycleDeposit: any = ''
    // E Data

    // S Methods
    reset() {
        this.form = {
            name: '',
            contact: '',
            contact_mobile: ''
        }

        this.getEarnestLists()
    }
    getEarnestLists() {
        this.pager.request({
            callback: apidepositRecordLists,
            params: {
                ...this.form
            }
        })
    }
    // E Methods

    // S  life cycle

    created() {
        this.getEarnestLists()
    }

    // E life cycle
}
